export const TextCell = ({ name, row }) => {
    return row[name] || null;
};
